export default {
  PhoneNumberFormField__ARIA: "Phone number",
  PhoneNumberFormField__CAPTION: "Use numbers only",
  PhoneNumberFormField__LABEL: "Phone number",
};
